import React, { useEffect } from 'react';
import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import type { CmdbObjectAttribute } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';
import type { CmdbObjectId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';

type Props = {
	attribute: CmdbObjectAttribute;
	objectId: CmdbObjectId;
};

export const UnknownAttribute = (props: Props) => {
	const {
		attribute: { objectTypeAttributeId, type },
		objectId,
	} = props;

	useEffect(() => {
		fireCmdbErrorAnalytics({
			meta: {
				id: 'attributesListRenderUnknownAttribute',
				packageName: 'jiraServicedeskInsightAttributeList',
				teamName: 'falcons',
			},
			error: new Error(
				`Unknown attribute type - object id: ${objectId}, object type attribute id: ${objectTypeAttributeId}, type: ${type}`,
			),
		});
	}, [objectId, objectTypeAttributeId, type]);

	return <>Unknown Attribute</>;
};
